import React, {Component, Fragment} from 'react';
import {Button, Form, FormGroup, Label, Row} from "reactstrap";
import CommonInput from "../common/common-input";
import {connect} from "react-redux";
import {
    actionGetPermissions,
    actionGetSingleRoleDetails,
    actionGetUserById,
    actionUpdateUserById
} from "../../actions/profile";
import {PAGE_TITLE} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import HeroSection from "../common/HerroSection/hero-section";

class AddUpdatePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: '',
            mobile: '',
            password: '',
            permission:[],
            errors: {}
        }
    }

    componentDidMount() {
        this.props.actionGetPermissions();

        if (this.props.match.params.id) {
            this.props.actionGetUserById(this.props.match.params.id)
        }

    }

    componentDidUpdate(prevProps, prevState) {
        prevProps.singlUser !== this.props.singlUser && this.setState({
            name: this.props.singlUser.name,
            email: this.props.singlUser.email,
            mobile: this.props.singlUser.mobile,
            password: this.props.singlUser.password,
            role: this.props.singlUser.role._id,
            permission:this.props.singlUser.permissions&&this.props.singlUser.permissions
        });

        if (prevProps.singleRoleDetails !== this.props.singleRoleDetails) {
            ((this.props.singleRoleDetails && this.props.singleRoleDetails.permissions) && this.props.singleRoleDetails.permissions.length > 0) && this.setState({
                permission: this.props.singleRoleDetails.permissions
            });
        }
    }


    handleSaveValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;

        if (!fields.name) {
            formIsValid = false;
            errors.name = "Please Enter Page Name...!";
        }
        if (!fields.email) {
            formIsValid = false;
            errors.email = "Please Enter Page Description ...!";
        }
        if (!fields.mobile) {
            formIsValid = false;
            errors.mobile = "Please Enter Page Title. ..!";
        }
        this.setState({errors: errors});
        return formIsValid;

    };

    onSaveSubmit = e => {
        e.preventDefault();
        if (this.handleSaveValidation()) {
            if (this.props.match.params.id) {
                const {name, email, role, mobile,permission} = this.state;
                const request = {
                    name,
                    email,
                    role,
                    mobile,
                    refId: this.props.user._id,
                    permissions:permission
                };
                this.props.actionUpdateUserById(this.props.match.params.id, request, this.props.history)
            }

        }
    };

    handleSelectPermission = e => this.state.permission.filter(p => p === e.target.value).length ?
        this.setState({permission: [...this.state.permission.filter(p => p !== e.target.value)]})
        :
        this.setState({permission: [...this.state.permission, e.target.value]});

    onChange = e => this.setState({[e.target.name]: e.target.value});

    render() {
        const {errors} = this.state;
        return (
            <Fragment>
                <Navbar scenario={PAGE_TITLE}/>
                <HeroSection title={this.props.match.params.id ? "Update Page" : 'Add Page'}/>
                <div className="container mt-5">
                    <Form className="card p-3 d-flex" autoComplete="off" noValidate={true} onSubmit={this.onSaveSubmit}>
                        <h3 className="text-center mb-2">{this.props.match.params.id ? "UPDATE PAGE" : 'ADD PAGE'}</h3>
                        <Row className="cards" style={{width: "100%"}} autoComplete="off" noValidate={true}>
                            <CommonInput
                                lbl={'Page Name:'}
                                name={'name'}
                                type={'text'}
                                value={this.state.name}
                                onChange={this.onChange}
                                errors={errors.name}
                                place={'Enter Page Name'}
                            />

                            <CommonInput
                                lbl={'Page Title:'}
                                name={'mobile'}
                                type={'text'}
                                value={this.state.mobile}
                                onChange={this.onChange}
                                errors={errors.mobile}
                                place={'Enter Page Title'}
                            />
                            <CommonInput
                                lbl={'Description:'}
                                name={'email'}
                                type={'textarea'}
                                value={this.state.email}
                                onChange={this.onChange}
                                errors={errors.email}
                                place={'Enter Description'}
                            />
                            <div className="col-12 rounded mt-3">
                                <Button type="submit">Save</Button>
                            </div>

                        </Row>
                    </Form>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    singlUser: state.profile.singlUser,
    role: state.profile.role,
    roleLoader: state.profile.roleLoader,
    singleRoleDetails: state.profile.singleRoleDetails,
    permissions: state.profile.permissions,
    permissionLoader: state.profile.permissionLoader,
    user: state.auth.user
});


export default connect(mapStateToProps, {
    actionGetUserById,
    actionUpdateUserById,
    actionGetSingleRoleDetails,
    actionGetPermissions
})(AddUpdatePage);

